import React, { useState } from 'react';
import PendingAttendancePane from '../components/PendingAttendancePane';
import RequestsPane from '../components/AttendanceRequestsPane';   // 部品に切り出した【2026-10-07】

// 出欠の訂正・公欠の申請（先生・教務）【2026-09-30】
//   学生がアプリから出した申請を見て、認める・認めない・説明を求める。
//   先生は担当の授業、教務は自分の大学の授業の申請が見える（サーバー側で絞っている）。
//   認めると、その回の出席が書き換わる（公欠は出席率の分母から外れる）。
// 【2026-10-01】「確認待ちの打刻」をタブで同じ画面に置いた（どちらも先生が出欠を確定する仕事）
// 【2026-10-07】embedded … 授業管理の「出欠の確認・修正」（すべての授業）の中に置くとき。見出しと外枠を出さない
export default function AttendanceRequests({ embedded = false }) {
  const [tab, setTab] = useState(() => {
    // ?tab=pending|requests が付いていればそれ（要対応の画面から飛んできたとき）【2026-11-02】
    try {
      const t = new URLSearchParams(window.location.search).get('tab');
      if (t === 'pending' || t === 'requests') return t;
    } catch (e) { /* 何もしない */ }
    try { return localStorage.getItem('requestsTab') || 'requests'; } catch (e) { return 'requests'; }
  });
  const choose = (t) => { setTab(t); try { localStorage.setItem('requestsTab', t); } catch (e) { /* 何もしない */ } };
  return (
    <div className={embedded ? undefined : 'page-container'}>
      {!embedded && <h2>出欠の確認</h2>}
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e5e7eb', marginBottom: '0.8rem' }}>
        {[['requests', '学生からの申請'], ['pending', '確認待ちの打刻']].map(([k, label]) => (
          <button key={k} onClick={() => choose(k)}
                  style={{ padding: '0.4rem 0.9rem', border: 'none', background: 'none', cursor: 'pointer',
                           borderBottom: tab === k ? '2px solid #2563eb' : '2px solid transparent',
                           color: tab === k ? '#1d4ed8' : '#555', fontWeight: tab === k ? 600 : 400 }}>
            {label}
          </button>
        ))}
      </div>
      {tab === 'pending' ? <PendingAttendancePane /> : <RequestsPane />}
    </div>
  );
}
